import { Box } from '@material-ui/core'
import HandlingInput from './HandlingInput'

const HandlingInputs = ({
  record,
  setPayload,
  payload,
  setRefresh,
  setErrors,
  errors,
}) => {
  if (!record) {
    return null
  }
  const input_columns = record?.state_transition?.input_columns
    ? record?.state_transition?.input_columns
    : []

  return (
    <>
      {input_columns.map((input) => {
        return (
          <Box sx={{ marginBottom: '16px' }}>
            <HandlingInput
              input={input}
              record={record}
              setPayload={setPayload}
              payload={payload}
              setRefresh={setRefresh}
              setErrors={setErrors}
              errors={errors}
            />
          </Box>
        )
      })}
    </>
  )
}

export default HandlingInputs
